/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: any; output: any; }
};

export type Query = {
  __typename?: 'Query';
  cities: Array<City>;
  regions: Array<Region>;
  districts: Array<District>;
  categories: Array<Category>;
  category?: Maybe<Category>;
  product?: Maybe<ProductItem>;
  productDetails?: Maybe<ClientProductDetailsResponse>;
  products: PaginatedProductResponse;
  productsSearch: PaginatedProductWithTopCategoryResponse;
  helpOrderMail: Scalars['Boolean']['output'];
  orders: PaginatedOrderResponse;
  order: ClientOrder;
  specificationRecognition: SpecificationRecognitionResponse;
  authIsRegistered: Scalars['Boolean']['output'];
  profile: Client;
  clientManagerContacts?: Maybe<ClientManagerContacts>;
  helpMail: Scalars['Boolean']['output'];
  companies: Array<Company>;
  company: Company;
  clientBillings: PaginatedCompanyBillingResponse;
  companyBillings: Array<CompanyBilling>;
  companyBilling: CompanyBilling;
  lookupCompanyByINN: CompanyData;
  lookupBankByBIK: BankData;
  helpRequestMail: Scalars['Boolean']['output'];
  requests: PaginatedRequestResponse;
  request: ClientRequest;
  autoSuggestProposals: Scalars['Boolean']['output'];
  statistics: Array<Statistic>;
};


export type QueryCitiesArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRegionsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDistrictsArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCategoriesArgs = {
  parent_id?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryCategoryArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductArgs = {
  product_id: Scalars['String']['input'];
};


export type QueryProductDetailsArgs = {
  product_id: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  category_id?: InputMaybe<Scalars['Int']['input']>;
  pagination: PaginationPayload;
};


export type QueryProductsSearchArgs = {
  search: Scalars['String']['input'];
  pagination: PaginationPayload;
};


export type QueryHelpOrderMailArgs = {
  orderId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type QueryOrdersArgs = {
  filter?: InputMaybe<OrdersListFilter>;
  pagination: PaginationPayload;
};


export type QueryOrderArgs = {
  id: Scalars['String']['input'];
};


export type QuerySpecificationRecognitionArgs = {
  id: Scalars['String']['input'];
};


export type QueryAuthIsRegisteredArgs = {
  email: Scalars['String']['input'];
};


export type QueryHelpMailArgs = {
  message: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['Int']['input'];
};


export type QueryClientBillingsArgs = {
  filter?: InputMaybe<BillingsListFilter>;
  pagination: PaginationPayload;
};


export type QueryCompanyBillingsArgs = {
  id: Scalars['Int']['input'];
};


export type QueryCompanyBillingArgs = {
  id: Scalars['Int']['input'];
};


export type QueryLookupCompanyByInnArgs = {
  inn: Scalars['String']['input'];
};


export type QueryLookupBankByBikArgs = {
  bik: Scalars['String']['input'];
};


export type QueryHelpRequestMailArgs = {
  requestId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};


export type QueryRequestsArgs = {
  filter?: InputMaybe<RequestsListFilter>;
  pagination: PaginationPayload;
};


export type QueryRequestArgs = {
  id: Scalars['String']['input'];
};


export type QueryAutoSuggestProposalsArgs = {
  request_id: Scalars['String']['input'];
};

export type City = {
  __typename?: 'City';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: Region;
  gmt_offset?: Maybe<Scalars['Int']['output']>;
};

export type Region = {
  __typename?: 'Region';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  district: District;
  gmt_offset: Scalars['Int']['output'];
};

export type District = {
  __typename?: 'District';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  parent_category?: Maybe<Category>;
  slug: Scalars['String']['output'];
  top_category?: Maybe<Category>;
};

export type ProductItem = {
  __typename?: 'ProductItem';
  id: Scalars['String']['output'];
  merchant_id: Scalars['Int']['output'];
  categories: Array<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  title_match: Scalars['String']['output'];
  price: Scalars['Float']['output'];
  amount: Scalars['Int']['output'];
  import_dt: Scalars['DateTimeISO']['output'];
  props: Array<ProductItemProp>;
  store: MerchantStore;
  vendor_code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  measure?: Maybe<ProductMeasureType>;
  supply_days?: Maybe<Scalars['Int']['output']>;
  price_autoprocessor_ids?: Maybe<Array<Scalars['String']['output']>>;
  images: Array<Image>;
};

export type ProductItemProp = {
  __typename?: 'ProductItemProp';
  id: Scalars['String']['output'];
  product_item: ProductItem;
  prop_id: ProductPropId;
  value_str1?: Maybe<Scalars['String']['output']>;
  value_str2?: Maybe<Scalars['String']['output']>;
  value_num1?: Maybe<Scalars['Float']['output']>;
  value_num2?: Maybe<Scalars['Float']['output']>;
  value_bool?: Maybe<Scalars['Boolean']['output']>;
  measure?: Maybe<MeasureType>;
};

export enum ProductPropId {
  Diameter = 'DIAMETER',
  DiameterEntry = 'DIAMETER_ENTRY',
  DiameterExit = 'DIAMETER_EXIT',
  DiameterOuter = 'DIAMETER_OUTER',
  DiameterInner = 'DIAMETER_INNER',
  Length = 'LENGTH',
  Width = 'WIDTH',
  Height = 'HEIGHT',
  Thickness = 'THICKNESS',
  Depth = 'DEPTH',
  Volume = 'VOLUME',
  Reinforcement = 'REINFORCEMENT',
  Material = 'MATERIAL',
  Coating = 'COATING',
  Carving = 'CARVING',
  ThreadType = 'THREAD_TYPE',
  ConnectionType = 'CONNECTION_TYPE',
  Color = 'COLOR',
  Fuel = 'FUEL',
  Power = 'POWER',
  ThermalPower = 'THERMAL_POWER',
  CoolingPower = 'COOLING_POWER',
  HeatingPower = 'HEATING_POWER',
  InstallationMethod = 'INSTALLATION_METHOD',
  MountingMethod = 'MOUNTING_METHOD',
  Shape = 'SHAPE',
  RatedCurrent = 'RATED_CURRENT',
  MaxCurrent = 'MAX_CURRENT',
  CurrentType = 'CURRENT_TYPE',
  NumberOfPhases = 'NUMBER_OF_PHASES',
  RatedVoltage = 'RATED_VOLTAGE',
  MaxVoltage = 'MAX_VOLTAGE',
  InputVoltage = 'INPUT_VOLTAGE',
  OutputVoltage = 'OUTPUT_VOLTAGE',
  Efficiency = 'EFFICIENCY',
  ProtectionDegree = 'PROTECTION_DEGREE',
  AttachType = 'ATTACH_TYPE',
  FittingConnection = 'FITTING_CONNECTION',
  OperatingPressure = 'OPERATING_PRESSURE',
  LiftingHeight = 'LIFTING_HEIGHT',
  DryRunningProtection = 'DRY_RUNNING_PROTECTION',
  ParticleSize = 'PARTICLE_SIZE',
  MaxLoad = 'MAX_LOAD',
  InstallationLength = 'INSTALLATION_LENGTH',
  DielectricCoating = 'DIELECTRIC_COATING',
  ProtectionClass = 'PROTECTION_CLASS',
  NoiseReduction = 'NOISE_REDUCTION',
  NoiseLevel = 'NOISE_LEVEL',
  GostStandard = 'GOST_STANDARD',
  SpoutLength = 'SPOUT_LENGTH',
  MixerType = 'MIXER_TYPE',
  ToiletOutlet = 'TOILET_OUTLET',
  AreaOfPremises = 'AREA_OF_PREMISES',
  ConditionerMode = 'CONDITIONER_MODE',
  AirConsumption = 'AIR_CONSUMPTION',
  RotationFrequency = 'ROTATION_FREQUENCY',
  InsulationMaterial = 'INSULATION_MATERIAL',
  ConductorMaterial = 'CONDUCTOR_MATERIAL',
  VeinsNumber = 'VEINS_NUMBER',
  VeinType = 'VEIN_TYPE',
  CableShape = 'CABLE_SHAPE',
  SelfRegulating = 'SELF_REGULATING',
  OperatingTemperature = 'OPERATING_TEMPERATURE',
  Shielded = 'SHIELDED',
  LuminousFlux = 'LUMINOUS_FLUX',
  LightTemperature = 'LIGHT_TEMPERATURE',
  HolderType = 'HOLDER_TYPE',
  SocketsNumber = 'SOCKETS_NUMBER',
  OutletsNumber = 'OUTLETS_NUMBER',
  DinAttach = 'DIN_ATTACH',
  CrossSection = 'CROSS_SECTION',
  FlapType = 'FLAP_TYPE',
  MatrixType = 'MATRIX_TYPE',
  ScreenDiagonal = 'SCREEN_DIAGONAL',
  ScreenRate = 'SCREEN_RATE',
  CamType = 'CAM_TYPE',
  PortsNumber = 'PORTS_NUMBER',
  CpuRate = 'CPU_RATE',
  CpuCores = 'CPU_CORES',
  Ram = 'RAM',
  Hdd = 'HDD',
  Manufacturer = 'MANUFACTURER',
  LayersCount = 'LAYERS_COUNT',
  CollectorType = 'COLLECTOR_TYPE',
  OutletsSize = 'OUTLETS_SIZE',
  Density = 'DENSITY',
  AdhesiveBacking = 'ADHESIVE_BACKING',
  SpecificWeight = 'SPECIFIC_WEIGHT',
  ThermalConductivity = 'THERMAL_CONDUCTIVITY',
  EfficiencyFactor = 'EFFICIENCY_FACTOR',
  CircuitsNumber = 'CIRCUITS_NUMBER',
  HeatingConnectionDiameter = 'HEATING_CONNECTION_DIAMETER',
  GasConnectionDiameter = 'GAS_CONNECTION_DIAMETER',
  NaturalGasConsumption = 'NATURAL_GAS_CONSUMPTION',
  AutoIgnition = 'AUTO_IGNITION',
  CombustionChamberType = 'COMBUSTION_CHAMBER_TYPE',
  ChimneyDiameter = 'CHIMNEY_DIAMETER',
  IgnitionType = 'IGNITION_TYPE',
  PowerInHeatingMode = 'POWER_IN_HEATING_MODE',
  PowerInCoolingMode = 'POWER_IN_COOLING_MODE',
  EnergyConsumptionClass = 'ENERGY_CONSUMPTION_CLASS',
  WorkingEnvPressure = 'WORKING_ENV_PRESSURE',
  InsulationPresence = 'INSULATION_PRESENCE',
  HeatExchangerMaterial = 'HEAT_EXCHANGER_MATERIAL',
  ControlType = 'CONTROL_TYPE',
  ThermostatType = 'THERMOSTAT_TYPE',
  SectionsCount = 'SECTIONS_COUNT',
  HeatTransfer = 'HEAT_TRANSFER',
  RadiatorConnectionMethod = 'RADIATOR_CONNECTION_METHOD',
  PlateThickness = 'PLATE_THICKNESS',
  PlateArea = 'PLATE_AREA',
  HeatTransferSurfaceArea = 'HEAT_TRANSFER_SURFACE_AREA',
  WorkingEnv = 'WORKING_ENV',
  Usage = 'USAGE',
  MinOperatingTemperature = 'MIN_OPERATING_TEMPERATURE',
  MaxOperatingTemperature = 'MAX_OPERATING_TEMPERATURE',
  Sdr = 'SDR',
  Mass = 'MASS',
  Guarantee = 'GUARANTEE',
  IgnitionGroup = 'IGNITION_GROUP',
  FlammabilityGroup = 'FLAMMABILITY_GROUP',
  SmokeGenGroup = 'SMOKE_GEN_GROUP',
  Nd = 'ND',
  Nd1 = 'ND1',
  Nd2 = 'ND2',
  Execution = 'EXECUTION',
  O2ProtectLayer = 'O2_PROTECT_LAYER',
  O2Permeability = 'O2_PERMEABILITY',
  ToxicCombustionProducts = 'TOXIC_COMBUSTION_PRODUCTS',
  HolesNumber = 'HOLES_NUMBER',
  ConnectionsNumber = 'CONNECTIONS_NUMBER',
  LinearExpansionCoefficient = 'LINEAR_EXPANSION_COEFFICIENT',
  MaxPressure = 'MAX_PRESSURE',
  MaxServiceLife = 'MAX_SERVICE_LIFE',
  SteelGrade = 'STEEL_GRADE',
  CrossAxisDistance = 'CROSS_AXIS_DISTANCE',
  MinBendRadius = 'MIN_BEND_RADIUS',
  Purpose = 'PURPOSE',
  NominalPressure = 'NOMINAL_PRESSURE',
  NutThread = 'NUT_THREAD',
  FittingThread = 'FITTING_THREAD',
  Pd = 'PD',
  MixerConnectionType = 'MIXER_CONNECTION_TYPE',
  BaseMaterialCrossLinkingDegree = 'BASE_MATERIAL_CROSS_LINKING_DEGREE',
  PlugType = 'PLUG_TYPE',
  CrossType = 'CROSS_TYPE',
  ConnType = 'CONN_TYPE',
  StitchingType = 'STITCHING_TYPE',
  PipeType = 'PIPE_TYPE',
  EvohLayerThickness = 'EVOH_LAYER_THICKNESS',
  WallThickness = 'WALL_THICKNESS',
  WallThickness1 = 'WALL_THICKNESS1',
  WallThickness2 = 'WALL_THICKNESS2',
  Angle = 'ANGLE',
  NominalPass = 'NOMINAL_PASS',
  MinPressure = 'MIN_PRESSURE',
  Bandwidth = 'BANDWIDTH',
  Verification = 'VERIFICATION',
  Pn = 'PN',
  PolesNumber = 'POLES_NUMBER',
  DisablingAbility = 'DISABLING_ABILITY',
  CurcuitBreakerCharacteristics = 'CURCUIT_BREAKER_CHARACTERISTICS',
  UncouplingType = 'UNCOUPLING_TYPE',
  LeakageCurrent = 'LEAKAGE_CURRENT',
  ElectricityMeterTariffs = 'ELECTRICITY_METER_TARIFFS',
  MinCrossSection = 'MIN_CROSS_SECTION',
  MaxCrossSection = 'MAX_CROSS_SECTION',
  PrimaryTransformerRatedCurrent = 'PRIMARY_TRANSFORMER_RATED_CURRENT',
  SecondaryTransformerRatedCurrent = 'SECONDARY_TRANSFORMER_RATED_CURRENT',
  DiameterAfterShrinkage = 'DIAMETER_AFTER_SHRINKAGE',
  PulseCurrent = 'PULSE_CURRENT',
  RatedDischargeCurrent = 'RATED_DISCHARGE_CURRENT',
  ProtectionVoltageLevel = 'PROTECTION_VOLTAGE_LEVEL'
}

export enum MeasureType {
  Amper = 'AMPER',
  Atmosphere = 'ATMOSPHERE',
  Bar = 'BAR',
  Celcius = 'CELCIUS',
  D = 'D',
  Decibell = 'DECIBELL',
  Degree = 'DEGREE',
  Gb = 'GB',
  Gram = 'GRAM',
  Hz = 'HZ',
  Inch = 'INCH',
  Kelvin = 'KELVIN',
  Kg = 'KG',
  KgPerMeter2 = 'KG_PER_METER2',
  KgPerMeter3 = 'KG_PER_METER3',
  KgSecPerCm2 = 'KG_SEC_PER_CM2',
  KgSecPerMeter3 = 'KG_SEC_PER_METER3',
  Kiloamper = 'KILOAMPER',
  Kilometr = 'KILOMETR',
  Kilovolt = 'KILOVOLT',
  Kilowatt = 'KILOWATT',
  Kit = 'KIT',
  Liter = 'LITER',
  LiterPerHour = 'LITER_PER_HOUR',
  LiterPerMinute = 'LITER_PER_MINUTE',
  Lumen = 'LUMEN',
  Megapascal = 'MEGAPASCAL',
  Meter = 'METER',
  Meter2 = 'METER2',
  Meter3 = 'METER3',
  Meter3PerHour = 'METER3_PER_HOUR',
  MgPerMeter2 = 'MG_PER_METER2',
  Mhz = 'MHZ',
  Micrometer = 'MICROMETER',
  Milliamper = 'MILLIAMPER',
  Millimeter = 'MILLIMETER',
  Millimeter2 = 'MILLIMETER2',
  Month = 'MONTH',
  Package = 'PACKAGE',
  Pascal = 'PASCAL',
  Percent = 'PERCENT',
  Piece = 'PIECE',
  Rpm = 'RPM',
  Section = 'SECTION',
  Set = 'SET',
  Tb = 'TB',
  Ton = 'TON',
  Volt = 'VOLT',
  Watt = 'WATT',
  WattPerMeterKelvin = 'WATT_PER_METER_KELVIN',
  WattPerMeter2Kelvin = 'WATT_PER_METER2_KELVIN',
  Year = 'YEAR'
}

export type MerchantStore = {
  __typename?: 'MerchantStore';
  id: Scalars['Int']['output'];
  merchant: Merchant;
  city: City;
  title: Scalars['String']['output'];
  address: Scalars['String']['output'];
  active: Scalars['Boolean']['output'];
};

export type Merchant = {
  __typename?: 'Merchant';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  inn?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  active: Scalars['Boolean']['output'];
  city?: Maybe<City>;
  status: MerchantStatus;
  last_contact_dt?: Maybe<Scalars['DateTimeISO']['output']>;
  created_at: Scalars['DateTimeISO']['output'];
  categories: Array<Scalars['Int']['output']>;
  billing?: Maybe<BillingDetails>;
  last_login?: Maybe<Scalars['DateTimeISO']['output']>;
  manager?: Maybe<Admin>;
  commission: Scalars['Int']['output'];
  agreement_accepted: Scalars['Boolean']['output'];
  stores?: Maybe<Array<MerchantStore>>;
  action_relation?: Maybe<Relation>;
};

export enum MerchantStatus {
  New = 'NEW',
  Working = 'WORKING',
  Disabled = 'DISABLED',
  Removed = 'REMOVED'
}

export type BillingDetails = {
  __typename?: 'BillingDetails';
  bik: Scalars['String']['output'];
  account: Scalars['String']['output'];
};

export type Admin = {
  __typename?: 'Admin';
  id: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
  personal?: Maybe<AdminPersonal>;
  created_at: Scalars['DateTimeISO']['output'];
  image?: Maybe<Image>;
  is_active: Scalars['Boolean']['output'];
  groups: Array<AdminGroup>;
  permissions: Array<AdminPermission>;
  features: Array<AdminFeatures>;
  is_restricted: Scalars['Boolean']['output'];
};

export type AdminPersonal = {
  __typename?: 'AdminPersonal';
  firstname: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  patronymic?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  id: Scalars['String']['output'];
  ratio: Scalars['Float']['output'];
  size: Array<ImageSize>;
  sort_order: Scalars['Int']['output'];
  product?: Maybe<ProductItem>;
  object_id?: Maybe<Scalars['String']['output']>;
};

export enum ImageSize {
  Xs = 'xs',
  Sm = 'sm',
  Lg = 'lg',
  Md = 'md',
  Xl = 'xl'
}

export enum AdminGroup {
  Admins = 'ADMINS',
  Merchants = 'MERCHANTS',
  Sales = 'SALES',
  Callcenter = 'CALLCENTER'
}

export enum AdminPermission {
  Orders = 'ORDERS',
  Requests = 'REQUESTS',
  Specifications = 'SPECIFICATIONS',
  Merchants = 'MERCHANTS',
  Clients = 'CLIENTS',
  StatisticSales = 'STATISTIC_SALES',
  StatisticMerchants = 'STATISTIC_MERCHANTS',
  StatisticPrices = 'STATISTIC_PRICES',
  Documentations = 'DOCUMENTATIONS',
  UtilitsZakupki = 'UTILITS_ZAKUPKI',
  UtilitsMail = 'UTILITS_MAIL',
  UtilitsCharacteristics = 'UTILITS_CHARACTERISTICS',
  Administration = 'ADMINISTRATION',
  Leads = 'LEADS',
  ActivityDetailed = 'ACTIVITY_DETAILED',
  ActivityOverview = 'ACTIVITY_OVERVIEW'
}

export enum AdminFeatures {
  OrdersNewNotification = 'ORDERS_NEW_NOTIFICATION',
  RequestsNewNotification = 'REQUESTS_NEW_NOTIFICATION',
  SpecificationsNewNotification = 'SPECIFICATIONS_NEW_NOTIFICATION',
  MerchantsRegisterNotification = 'MERCHANTS_REGISTER_NOTIFICATION',
  MerchantsContactNotification = 'MERCHANTS_CONTACT_NOTIFICATION'
}

export type Relation = {
  __typename?: 'Relation';
  id: Scalars['String']['output'];
  merchant?: Maybe<Merchant>;
  client?: Maybe<Client>;
  order?: Maybe<Order>;
  lead?: Maybe<Lead>;
  request?: Maybe<Request>;
  notes: Scalars['String']['output'];
  contact_dt: Scalars['DateTimeISO']['output'];
  action_dt?: Maybe<Scalars['DateTimeISO']['output']>;
  is_resolved?: Maybe<Scalars['Boolean']['output']>;
  admin?: Maybe<Admin>;
  assigned_to?: Maybe<Admin>;
  assigned_group?: Maybe<AdminGroup>;
  is_important: Scalars['Boolean']['output'];
  is_full_day: Scalars['Boolean']['output'];
  is_removed: Scalars['Boolean']['output'];
  is_pinned: Scalars['Boolean']['output'];
};

export type Client = {
  __typename?: 'Client';
  id: Scalars['Int']['output'];
  email: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  created_at: Scalars['DateTimeISO']['output'];
  city?: Maybe<City>;
  personal?: Maybe<ClientPersonal>;
  category?: Maybe<ClientCategory>;
  billing?: Maybe<BillingDetails>;
  manager?: Maybe<Admin>;
  clientCompanies?: Maybe<Array<ClientCompany>>;
  companies: Array<Company>;
  notes?: Maybe<Scalars['String']['output']>;
  last_contact_dt?: Maybe<Scalars['DateTimeISO']['output']>;
  action_relation?: Maybe<Relation>;
  is_self_sufficient: Scalars['Boolean']['output'];
  referal_id?: Maybe<Scalars['String']['output']>;
};

export type ClientPersonal = {
  __typename?: 'ClientPersonal';
  firstname: Scalars['String']['output'];
  surname: Scalars['String']['output'];
  patronymic?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['String']['output']>;
};

export enum ClientCategory {
  Builder = 'BUILDER',
  Commercial = 'COMMERCIAL',
  Government = 'GOVERNMENT',
  Projector = 'PROJECTOR',
  Individual = 'INDIVIDUAL'
}

export type ClientCompany = {
  __typename?: 'ClientCompany';
  id: Scalars['Float']['output'];
  client: Client;
  company: Company;
};

export type Company = {
  __typename?: 'Company';
  id: Scalars['Int']['output'];
  companyClients?: Maybe<Array<ClientCompany>>;
  clients: Array<Client>;
  inn: Scalars['String']['output'];
  name: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
};

export type Order = {
  __typename?: 'Order';
  id: Scalars['String']['output'];
  created_at: Scalars['DateTimeISO']['output'];
  client: Client;
  company?: Maybe<Company>;
  status: OrderStatus;
  summ: Scalars['Float']['output'];
  comments: Scalars['String']['output'];
  num: Scalars['String']['output'];
  delivery_summ?: Maybe<Scalars['Float']['output']>;
  delivery_address: Scalars['String']['output'];
  request?: Maybe<Request>;
  order_merchants: Array<OrderMerchant>;
  last_contact?: Maybe<Scalars['DateTimeISO']['output']>;
  action_relation?: Maybe<Relation>;
};

export enum OrderStatus {
  New = 'NEW',
  Confirmed = 'CONFIRMED',
  Payed = 'PAYED',
  Delivery = 'DELIVERY',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED',
  Draft = 'DRAFT'
}

export type Request = {
  __typename?: 'Request';
  id: Scalars['String']['output'];
  num: Scalars['String']['output'];
  created_at: Scalars['DateTimeISO']['output'];
  client: Client;
  manager?: Maybe<Admin>;
  city: City;
  address: Scalars['String']['output'];
  regionsIds: Array<Scalars['Int']['output']>;
  districtsIds: Array<Scalars['Int']['output']>;
  status: RequestStatus;
  comment?: Maybe<Scalars['String']['output']>;
  categoriesIds: Array<Scalars['Int']['output']>;
  last_contact?: Maybe<Scalars['DateTimeISO']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  specification?: Maybe<Specification>;
  action_relation?: Maybe<Relation>;
  search_criterias?: Maybe<RequestSearchCriterias>;
};

export enum RequestStatus {
  Open = 'OPEN',
  Canceled = 'CANCELED',
  Ordered = 'ORDERED',
  Sended = 'SENDED',
  Closed = 'CLOSED',
  Draft = 'DRAFT'
}

export type Specification = {
  __typename?: 'Specification';
  id: Scalars['String']['output'];
  client: Client;
  comment?: Maybe<Scalars['String']['output']>;
  files: Array<SpecificationFile>;
  created_at: Scalars['DateTimeISO']['output'];
  status: SpecificationStatus;
  delivery_address: Scalars['String']['output'];
  recognition_status: SpecificationRecognitionStatus;
};

export type SpecificationFile = {
  __typename?: 'SpecificationFile';
  filename: Scalars['String']['output'];
  original_filename: Scalars['String']['output'];
};

export enum SpecificationStatus {
  New = 'NEW',
  Closed = 'CLOSED'
}

export enum SpecificationRecognitionStatus {
  Progress = 'PROGRESS',
  Successfully = 'SUCCESSFULLY',
  Failed = 'FAILED'
}

export type RequestSearchCriterias = {
  __typename?: 'RequestSearchCriterias';
  product_type?: Maybe<RequestSearchCriteriasProductType>;
  priority?: Maybe<Array<RequestSearchCriteriasPriority>>;
  comments?: Maybe<Scalars['String']['output']>;
  delivery_days?: Maybe<Scalars['Int']['output']>;
};

export enum RequestSearchCriteriasProductType {
  Original = 'ORIGINAL',
  Analog = 'ANALOG'
}

export enum RequestSearchCriteriasPriority {
  Price = 'PRICE',
  Delivery = 'DELIVERY'
}

export type OrderMerchant = {
  __typename?: 'OrderMerchant';
  id: Scalars['String']['output'];
  order: Order;
  merchant: Merchant;
  status: OrderMerchantStatus;
  delivery: DeliveryDetails;
};

export enum OrderMerchantStatus {
  New = 'NEW',
  Confirmed = 'CONFIRMED',
  Payed = 'PAYED',
  Delivery = 'DELIVERY',
  Completed = 'COMPLETED',
  Canceled = 'CANCELED'
}

export type DeliveryDetails = {
  __typename?: 'DeliveryDetails';
  operator?: Maybe<DeliveryOperator>;
  tarif?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  days?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  trackUrl?: Maybe<Scalars['String']['output']>;
  status: DeliveryStatus;
};

export enum DeliveryOperator {
  Cdek = 'CDEK'
}

export enum DeliveryStatus {
  Draft = 'DRAFT',
  Created = 'CREATED',
  Delivery = 'DELIVERY',
  Delivered = 'DELIVERED'
}

export type Lead = {
  __typename?: 'Lead';
  id: Scalars['String']['output'];
  created_at: Scalars['DateTimeISO']['output'];
  org_name: Scalars['String']['output'];
  inn: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  source_link?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Region>;
  status: LeadStatus;
  notes?: Maybe<Scalars['String']['output']>;
  manager?: Maybe<Admin>;
  last_contact?: Maybe<Scalars['DateTimeISO']['output']>;
  lead_type: LeadType;
  client_category?: Maybe<ClientCategory>;
  action_relation?: Maybe<Relation>;
  calls_count: Scalars['Int']['output'];
};

export enum LeadStatus {
  New = 'NEW',
  Inwork = 'INWORK',
  Agree = 'AGREE',
  Decline = 'DECLINE',
  Invalid = 'INVALID',
  Registered = 'REGISTERED',
  Duplicate = 'DUPLICATE'
}

export enum LeadType {
  Client = 'CLIENT',
  Merchant = 'MERCHANT'
}

export enum ProductMeasureType {
  Piece = 'PIECE',
  Kg = 'KG',
  Meter = 'METER',
  Gram = 'GRAM',
  Millimeter = 'MILLIMETER',
  Meter2 = 'METER2',
  Meter3 = 'METER3',
  Set = 'SET',
  Ton = 'TON',
  Package = 'PACKAGE',
  Section = 'SECTION',
  Kilometr = 'KILOMETR',
  Kit = 'KIT'
}

export type ClientProductDetailsResponse = {
  __typename?: 'ClientProductDetailsResponse';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vendor_code?: Maybe<Scalars['String']['output']>;
  store: MerchantStore;
  measure?: Maybe<ProductMeasureType>;
  images: Array<Image>;
  categories: Array<Scalars['Int']['output']>;
  amount: Scalars['Int']['output'];
  top_category?: Maybe<Scalars['Int']['output']>;
  price: Scalars['Float']['output'];
  supply_days?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type PaginatedProductResponse = {
  __typename?: 'PaginatedProductResponse';
  totalCount: Scalars['Int']['output'];
  data: Array<ProductItem>;
};

export type PaginationPayload = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};

export type PaginatedProductWithTopCategoryResponse = {
  __typename?: 'PaginatedProductWithTopCategoryResponse';
  totalCount: Scalars['Int']['output'];
  data: Array<ClientProductDetailsResponse>;
};

export type PaginatedOrderResponse = {
  __typename?: 'PaginatedOrderResponse';
  totalCount: Scalars['Int']['output'];
  data: Array<Order>;
};

export type OrdersListFilter = {
  statuses?: InputMaybe<Array<OrderStatus>>;
};

export type ClientOrder = {
  __typename?: 'ClientOrder';
  id: Scalars['String']['output'];
  num: Scalars['String']['output'];
  created_at: Scalars['DateTimeISO']['output'];
  items: Array<ClientOrderItem>;
  status: OrderStatus;
  summ: Scalars['Float']['output'];
  delivery_summ?: Maybe<Scalars['Float']['output']>;
  delivery_address: Scalars['String']['output'];
  request?: Maybe<Request>;
};

export type ClientOrderItem = {
  __typename?: 'ClientOrderItem';
  orderItem: OrderItem;
  productItem: ProductItem;
};

export type OrderItem = {
  __typename?: 'OrderItem';
  id: Scalars['String']['output'];
  order_merchant: OrderMerchant;
  product: ProductItem;
  request_item?: Maybe<RequestItem>;
  request_proposal_item?: Maybe<RequestProposalItem>;
  amount: Scalars['Int']['output'];
  sort_order: Scalars['Int']['output'];
  price: Scalars['Float']['output'];
  supply_days?: Maybe<Scalars['Int']['output']>;
  status: OrderItemStatus;
  store_amount: Scalars['Int']['output'];
  position_num?: Maybe<Scalars['Int']['output']>;
};

export type RequestItem = {
  __typename?: 'RequestItem';
  id: Scalars['String']['output'];
  request: Request;
  title: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  measure?: Maybe<ProductMeasureType>;
  category_id?: Maybe<Scalars['Int']['output']>;
  sort_order: Scalars['Int']['output'];
};

export type RequestProposalItem = {
  __typename?: 'RequestProposalItem';
  id: Scalars['String']['output'];
  requestProposal: RequestProposal;
  requestItem: RequestItem;
  productItem: ProductItem;
  price: Scalars['Float']['output'];
  amount: Scalars['Int']['output'];
  supply_days?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  position_num: Scalars['Int']['output'];
};

export type RequestProposal = {
  __typename?: 'RequestProposal';
  id: Scalars['String']['output'];
  request: Request;
  merchant: Merchant;
  status: RequestProposalStatus;
};

export enum RequestProposalStatus {
  New = 'NEW',
  Draft = 'DRAFT',
  Submited = 'SUBMITED',
  Deleted = 'DELETED'
}

export enum OrderItemStatus {
  Draft = 'DRAFT',
  Ordered = 'ORDERED',
  Rejected = 'REJECTED',
  Approved = 'APPROVED',
  Changed = 'CHANGED'
}

export type SpecificationRecognitionResponse = {
  __typename?: 'SpecificationRecognitionResponse';
  recognition_status: SpecificationRecognitionStatus;
  request_id?: Maybe<Scalars['String']['output']>;
};

export type ClientManagerContacts = {
  __typename?: 'ClientManagerContacts';
  email: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type PaginatedCompanyBillingResponse = {
  __typename?: 'PaginatedCompanyBillingResponse';
  totalCount: Scalars['Int']['output'];
  data: Array<CompanyBilling>;
};

export type CompanyBilling = {
  __typename?: 'CompanyBilling';
  id: Scalars['Int']['output'];
  clientCompany: ClientCompany;
  bik: Scalars['String']['output'];
  bank_name?: Maybe<Scalars['String']['output']>;
  account: Scalars['String']['output'];
  is_active: Scalars['Boolean']['output'];
};

export type BillingsListFilter = {
  is_active?: InputMaybe<Scalars['Boolean']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyData = {
  __typename?: 'CompanyData';
  name?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
};

export type BankData = {
  __typename?: 'BankData';
  name?: Maybe<Scalars['String']['output']>;
};

export type PaginatedRequestResponse = {
  __typename?: 'PaginatedRequestResponse';
  totalCount: Scalars['Int']['output'];
  data: Array<Request>;
};

export type RequestsListFilter = {
  statuses?: InputMaybe<Array<RequestStatus>>;
};

export type ClientRequest = {
  __typename?: 'ClientRequest';
  id: Scalars['String']['output'];
  num: Scalars['String']['output'];
  created_at: Scalars['DateTimeISO']['output'];
  city: City;
  address: Scalars['String']['output'];
  status: RequestStatus;
  comment?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  requestItems: Array<ClientRequestItem>;
  orderItems?: Maybe<Array<OrderItem>>;
  orders?: Maybe<Array<Order>>;
  specification?: Maybe<Specification>;
};

export type ClientRequestItem = {
  __typename?: 'ClientRequestItem';
  id: Scalars['String']['output'];
  request: Request;
  title: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  measure?: Maybe<ProductMeasureType>;
  category_id?: Maybe<Scalars['Int']['output']>;
  sort_order: Scalars['Int']['output'];
  proposals: Array<RequestProposalItem>;
};

export type Statistic = {
  __typename?: 'Statistic';
  id: Scalars['String']['output'];
  data: StatisticData;
};

export type StatisticData = {
  __typename?: 'StatisticData';
  merchants?: Maybe<Scalars['Int']['output']>;
  products?: Maybe<Scalars['Int']['output']>;
  recognizedProducts?: Maybe<Scalars['Int']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  placeOrder: Order;
  cancelOrder: Scalars['Boolean']['output'];
  changeOrderItem: OrderItem;
  specificationRequest: Specification;
  login: LoginResponse;
  register: LoginResponse;
  restorePasswordSendCode: RestoreResponse;
  restorePasswordFinish: Scalars['Boolean']['output'];
  fastLogin: LoginResponse;
  profileUpdate: Client;
  cityUpdate: Scalars['Boolean']['output'];
  companyCreate: Company;
  companyBillingCreate: CompanyBilling;
  companyBillingUpdate: CompanyBilling;
  placeRequest: Request;
  requestClose: Scalars['Boolean']['output'];
  requestOpen: Scalars['Boolean']['output'];
  requestDelete: Scalars['Boolean']['output'];
  requestOrderDraft: Order;
  requestOrder: Order;
  newInvestLead: Scalars['Boolean']['output'];
  sendSuggestion: Scalars['Boolean']['output'];
  contactManager: Scalars['Boolean']['output'];
};


export type MutationPlaceOrderArgs = {
  summ?: InputMaybe<Scalars['Float']['input']>;
  companyId: Scalars['Int']['input'];
  address: Scalars['String']['input'];
  items: Array<OrderItemInput>;
};


export type MutationCancelOrderArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeOrderItemArgs = {
  status: Scalars['Float']['input'];
  orderItemId: Scalars['String']['input'];
};


export type MutationSpecificationRequestArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  files?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationRegisterArgs = {
  data: RegisterPayload;
};


export type MutationRestorePasswordSendCodeArgs = {
  email: Scalars['String']['input'];
};


export type MutationRestorePasswordFinishArgs = {
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
  checkId: Scalars['String']['input'];
};


export type MutationFastLoginArgs = {
  code: Scalars['String']['input'];
  checkId: Scalars['String']['input'];
};


export type MutationProfileUpdateArgs = {
  data: ProfilePayload;
};


export type MutationCityUpdateArgs = {
  cityId: Scalars['Int']['input'];
};


export type MutationCompanyCreateArgs = {
  data: CompanyPayload;
};


export type MutationCompanyBillingCreateArgs = {
  data: BillingPayload;
  id: Scalars['Int']['input'];
};


export type MutationCompanyBillingUpdateArgs = {
  data: BillingPayload;
  id: Scalars['Int']['input'];
};


export type MutationPlaceRequestArgs = {
  request_id?: InputMaybe<Scalars['String']['input']>;
  data: RequestPayload;
};


export type MutationRequestCloseArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestOpenArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestDeleteArgs = {
  id: Scalars['String']['input'];
};


export type MutationRequestOrderDraftArgs = {
  companyId?: InputMaybe<Scalars['Int']['input']>;
  items: Array<RequestOrderItemPayload>;
  requestId: Scalars['String']['input'];
};


export type MutationRequestOrderArgs = {
  requestId: Scalars['String']['input'];
};


export type MutationNewInvestLeadArgs = {
  notes: Scalars['String']['input'];
  lead: InvestLeadPayload;
};


export type MutationSendSuggestionArgs = {
  suggestion: SuggestionPayload;
};


export type MutationContactManagerArgs = {
  suggestion: SuggestionPayload;
};

export type OrderItemInput = {
  product_id: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  city: City;
};

export type RegisterPayload = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  cityId: Scalars['Int']['input'];
  firstname: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  patronymic?: InputMaybe<Scalars['String']['input']>;
  referalId?: InputMaybe<Scalars['String']['input']>;
};

export type RestoreResponse = {
  __typename?: 'RestoreResponse';
  checkId: Scalars['String']['output'];
};

export type ProfilePayload = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  personal: ClientPersonalInput;
};

export type ClientPersonalInput = {
  firstname: Scalars['String']['input'];
  surname: Scalars['String']['input'];
  patronymic?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
};

export type CompanyPayload = {
  inn: Scalars['String']['input'];
  name: Scalars['String']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
};

export type BillingPayload = {
  bik: Scalars['String']['input'];
  bank_name: Scalars['String']['input'];
  account: Scalars['String']['input'];
  is_active: Scalars['Boolean']['input'];
};

export type RequestPayload = {
  cityId: Scalars['Int']['input'];
  address: Scalars['String']['input'];
  regions: Array<Scalars['Int']['input']>;
  districts: Array<Scalars['Int']['input']>;
  items: Array<RequestItemPayload>;
  comment?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RequestItemPayload = {
  title: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  measure: ProductMeasureType;
  categoryId: Scalars['Int']['input'];
};

export type RequestOrderItemPayload = {
  product_id: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  request_item_id: Scalars['String']['input'];
  request_proposal_item_id?: InputMaybe<Scalars['String']['input']>;
};

export type InvestLeadPayload = {
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  name: Scalars['String']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  telegram?: InputMaybe<Scalars['String']['input']>;
  preferredContact: Scalars['String']['input'];
  investment_volume?: InputMaybe<Scalars['Int']['input']>;
};

export type SuggestionPayload = {
  emailPhone?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  options: Array<SuggestionOption>;
  name?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionOption = {
  label: Scalars['String']['input'];
  value: Array<SuggestionValue>;
  other?: InputMaybe<Scalars['String']['input']>;
};

export type SuggestionValue = {
  value: Scalars['String']['input'];
  extra?: InputMaybe<Scalars['String']['input']>;
};

export type AllCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, title: string, slug: string, parent_category?: { __typename?: 'Category', id: number } | null, top_category?: { __typename?: 'Category', id: number } | null }> };

export type DataQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type DataQuery = { __typename?: 'Query', productDetails?: { __typename?: 'ClientProductDetailsResponse', title: string, id: string, vendor_code?: string | null, measure?: ProductMeasureType | null, amount: number, supply_days?: number | null, description?: string | null, price: number, top_category?: number | null, store: { __typename?: 'MerchantStore', city: { __typename?: 'City', name: string } }, images: Array<{ __typename?: 'Image', id: string, sort_order: number }> } | null };

export type SubCategoriesQueryVariables = Exact<{
  parent_id: Scalars['Int']['input'];
}>;


export type SubCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: number, title: string, slug: string, top_category?: { __typename?: 'Category', id: number } | null }> };

export type GetCategoriesBySlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type GetCategoriesBySlugQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, title: string, slug: string, parent_category?: { __typename?: 'Category', id: number, title: string, slug: string } | null, top_category?: { __typename?: 'Category', id: number } | null } | null };

export type GetCategoryByIdQueryVariables = Exact<{
  category_id: Scalars['Int']['input'];
}>;


export type GetCategoryByIdQuery = { __typename?: 'Query', category?: { __typename?: 'Category', id: number, title: string, slug: string, parent_category?: { __typename?: 'Category', id: number, title: string, slug: string } | null, top_category?: { __typename?: 'Category', id: number } | null } | null };

export type StatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type StatisticsQuery = { __typename?: 'Query', statistics: Array<{ __typename?: 'Statistic', data: { __typename?: 'StatisticData', products?: number | null, merchants?: number | null } }> };

export type CitiesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type CitiesQuery = { __typename?: 'Query', cities: Array<{ __typename?: 'City', id: number, name: string, gmt_offset?: number | null, region: { __typename?: 'Region', id: number, name: string, gmt_offset: number, district: { __typename?: 'District', id: number, name: string } } }> };

export type NewInvestLeadMutationVariables = Exact<{
  lead: InvestLeadPayload;
  notes: Scalars['String']['input'];
}>;


export type NewInvestLeadMutation = { __typename?: 'Mutation', newInvestLead: boolean };

export type PlaceOrderMutationVariables = Exact<{
  summ?: InputMaybe<Scalars['Float']['input']>;
  items: Array<OrderItemInput> | OrderItemInput;
  address: Scalars['String']['input'];
  companyId: Scalars['Int']['input'];
}>;


export type PlaceOrderMutation = { __typename?: 'Mutation', placeOrder: { __typename?: 'Order', id: string } };

export type ChangeOrderItemMutationVariables = Exact<{
  status: Scalars['Float']['input'];
  orderItemId: Scalars['String']['input'];
}>;


export type ChangeOrderItemMutation = { __typename?: 'Mutation', changeOrderItem: { __typename?: 'OrderItem', id: string } };

export type RegionsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', id: number, name: string }> };

export type DistrictsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type DistrictsQuery = { __typename?: 'Query', districts: Array<{ __typename?: 'District', id: number, name: string }> };

export type AuthIsRegisteredQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AuthIsRegisteredQuery = { __typename?: 'Query', authIsRegistered: boolean };

export type LoginMutationVariables = Exact<{
  password: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'LoginResponse', token: string, city: { __typename?: 'City', id: number, name: string, region: { __typename?: 'Region', id: number, name: string, district: { __typename?: 'District', id: number, name: string } } } } };

export type RegisterMutationVariables = Exact<{
  data: RegisterPayload;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'LoginResponse', token: string, city: { __typename?: 'City', id: number, name: string, region: { __typename?: 'Region', id: number, name: string, district: { __typename?: 'District', id: number, name: string } } } } };

export type RestorePasswordSendCodeMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RestorePasswordSendCodeMutation = { __typename?: 'Mutation', restorePasswordSendCode: { __typename?: 'RestoreResponse', checkId: string } };

export type RestorePasswordFinishMutationVariables = Exact<{
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
  checkId: Scalars['String']['input'];
}>;


export type RestorePasswordFinishMutation = { __typename?: 'Mutation', restorePasswordFinish: boolean };

export type FastLoginMutationVariables = Exact<{
  checkId: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type FastLoginMutation = { __typename?: 'Mutation', fastLogin: { __typename?: 'LoginResponse', token: string, city: { __typename?: 'City', id: number, name: string, region: { __typename?: 'Region', id: number, name: string, district: { __typename?: 'District', id: number, name: string } } } } };

export type GetProductsPaginatedQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  category_id: Scalars['Int']['input'];
}>;


export type GetProductsPaginatedQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedProductResponse', totalCount: number, data: Array<{ __typename?: 'ProductItem', id: string, title: string, price: number, amount: number, measure?: ProductMeasureType | null, supply_days?: number | null, store: { __typename?: 'MerchantStore', city: { __typename?: 'City', name: string } }, images: Array<{ __typename?: 'Image', id: string, sort_order: number }> }> } };

export type GetProductsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  search: Scalars['String']['input'];
}>;


export type GetProductsQuery = { __typename?: 'Query', products: { __typename?: 'PaginatedProductWithTopCategoryResponse', totalCount: number, data: Array<{ __typename?: 'ClientProductDetailsResponse', id: string, title: string, price: number, amount: number, measure?: ProductMeasureType | null, top_category?: number | null, supply_days?: number | null, store: { __typename?: 'MerchantStore', city: { __typename?: 'City', name: string } }, images: Array<{ __typename?: 'Image', id: string, sort_order: number }> }> } };

export type ProductDetailsQueryVariables = Exact<{
  productId: Scalars['String']['input'];
}>;


export type ProductDetailsQuery = { __typename?: 'Query', productDetails?: { __typename?: 'ClientProductDetailsResponse', title: string, id: string, vendor_code?: string | null, measure?: ProductMeasureType | null, amount: number, supply_days?: number | null, description?: string | null, price: number, top_category?: number | null, store: { __typename?: 'MerchantStore', city: { __typename?: 'City', name: string } }, images: Array<{ __typename?: 'Image', id: string, sort_order: number }> } | null };

export type SendSuggestionMutationVariables = Exact<{
  suggestion: SuggestionPayload;
}>;


export type SendSuggestionMutation = { __typename?: 'Mutation', sendSuggestion: boolean };

export type ContactManagerMutationVariables = Exact<{
  suggestion: SuggestionPayload;
}>;


export type ContactManagerMutation = { __typename?: 'Mutation', contactManager: boolean };

export type SpecificationRequestMutationVariables = Exact<{
  address: Scalars['String']['input'];
  files?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type SpecificationRequestMutation = { __typename?: 'Mutation', specificationRequest: { __typename?: 'Specification', id: string } };

export type SpecificationRecognitionQueryQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SpecificationRecognitionQueryQuery = { __typename?: 'Query', specificationRecognition: { __typename?: 'SpecificationRecognitionResponse', recognition_status: SpecificationRecognitionStatus, request_id?: string | null } };

export type CompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: number, inn: string, name: string, address?: string | null }> };

export type CompanyQueryVariables = Exact<{
  companyId: Scalars['Int']['input'];
}>;


export type CompanyQuery = { __typename?: 'Query', company: { __typename?: 'Company', id: number, inn: string, name: string, address?: string | null }, companyBillings: Array<{ __typename?: 'CompanyBilling', id: number, bik: string, bank_name?: string | null, account: string, is_active: boolean }> };

export type CompanyCreateMutationVariables = Exact<{
  data: CompanyPayload;
}>;


export type CompanyCreateMutation = { __typename?: 'Mutation', companyCreate: { __typename?: 'Company', id: number, address?: string | null, inn: string, name: string } };

export type CompanyBillingQueryVariables = Exact<{
  billingId: Scalars['Int']['input'];
}>;


export type CompanyBillingQuery = { __typename?: 'Query', companyBilling: { __typename?: 'CompanyBilling', id: number, is_active: boolean, bik: string, bank_name?: string | null, account: string } };

export type CompanyBillingCreateMutationVariables = Exact<{
  data: BillingPayload;
  companyId: Scalars['Int']['input'];
}>;


export type CompanyBillingCreateMutation = { __typename?: 'Mutation', companyBillingCreate: { __typename?: 'CompanyBilling', id: number } };

export type CompanyBillingUpdateMutationVariables = Exact<{
  data: BillingPayload;
  billingId: Scalars['Int']['input'];
}>;


export type CompanyBillingUpdateMutation = { __typename?: 'Mutation', companyBillingUpdate: { __typename?: 'CompanyBilling', id: number } };

export type LookupCompanyByInnQueryVariables = Exact<{
  inn: Scalars['String']['input'];
}>;


export type LookupCompanyByInnQuery = { __typename?: 'Query', company: { __typename?: 'CompanyData', name?: string | null, address?: string | null } };

export type LookupBankByBikQueryVariables = Exact<{
  bik: Scalars['String']['input'];
}>;


export type LookupBankByBikQuery = { __typename?: 'Query', bank: { __typename?: 'BankData', name?: string | null } };

export type ProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type ProfileQuery = { __typename?: 'Query', profile: { __typename?: 'Client', id: number, email: string, phone?: string | null, personal?: { __typename?: 'ClientPersonal', firstname: string, surname: string, patronymic?: string | null, position?: string | null } | null, billing?: { __typename?: 'BillingDetails', bik: string, account: string } | null, manager?: { __typename?: 'Admin', id: number, email: string, phone: string, image?: { __typename?: 'Image', id: string } | null, personal?: { __typename?: 'AdminPersonal', firstname: string, patronymic?: string | null, surname: string } | null } | null } };

export type ProfileUpdateMutationVariables = Exact<{
  data: ProfilePayload;
}>;


export type ProfileUpdateMutation = { __typename?: 'Mutation', profileUpdate: { __typename?: 'Client', id: number } };

export type CityUpdateMutationVariables = Exact<{
  cityId: Scalars['Int']['input'];
}>;


export type CityUpdateMutation = { __typename?: 'Mutation', cityUpdate: boolean };

export type HelpMailQueryVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type HelpMailQuery = { __typename?: 'Query', helpMail: boolean };

export type OrdersQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filter?: InputMaybe<OrdersListFilter>;
}>;


export type OrdersQuery = { __typename?: 'Query', orders: { __typename?: 'PaginatedOrderResponse', totalCount: number, data: Array<{ __typename?: 'Order', id: string, created_at: any, summ: number, status: OrderStatus, num: string }> } };

export type MutationMutationVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type MutationMutation = { __typename?: 'Mutation', cancelOrder: boolean };

export type OrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', order: { __typename?: 'ClientOrder', id: string, status: OrderStatus, summ: number, delivery_summ?: number | null, delivery_address: string, num: string, created_at: any, items: Array<{ __typename?: 'ClientOrderItem', productItem: { __typename?: 'ProductItem', id: string, amount: number, price: number, supply_days?: number | null, title: string, store: { __typename?: 'MerchantStore', id: number, title: string, city: { __typename?: 'City', id: number, name: string, region: { __typename?: 'Region', name: string, id: number } } } }, orderItem: { __typename?: 'OrderItem', id: string, amount: number, price: number, status: OrderItemStatus, store_amount: number, supply_days?: number | null, position_num?: number | null, request_proposal_item?: { __typename?: 'RequestProposalItem', id: string, price: number, amount: number, supply_days?: number | null } | null } }>, request?: { __typename?: 'Request', id: string, num: string } | null } };

export type HelpMailOrderQueryVariables = Exact<{
  orderId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type HelpMailOrderQuery = { __typename?: 'Query', helpOrderMail: boolean };

export type QueryQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  filter?: InputMaybe<RequestsListFilter>;
}>;


export type QueryQuery = { __typename?: 'Query', requests: { __typename?: 'PaginatedRequestResponse', totalCount: number, data: Array<{ __typename?: 'Request', status: RequestStatus, created_at: any, id: string, num: string, title?: string | null }> } };

export type RequestQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type RequestQuery = { __typename?: 'Query', request: { __typename?: 'ClientRequest', id: string, num: string, status: RequestStatus, address: string, comment?: string | null, title?: string | null, created_at: any, city: { __typename?: 'City', id: number, name: string, region: { __typename?: 'Region', name: string } }, specification?: { __typename?: 'Specification', id: string } | null, requestItems: Array<{ __typename?: 'ClientRequestItem', id: string, title: string, amount: number, measure?: ProductMeasureType | null, category_id?: number | null, proposals: Array<{ __typename?: 'RequestProposalItem', id: string, price: number, amount: number, supply_days?: number | null, requestItem: { __typename?: 'RequestItem', id: string, amount: number }, productItem: { __typename?: 'ProductItem', id: string, title: string, price: number, amount: number, supply_days?: number | null, store: { __typename?: 'MerchantStore', id: number, city: { __typename?: 'City', name: string } } } }> }>, orderItems?: Array<{ __typename?: 'OrderItem', id: string, amount: number, price: number, status: OrderItemStatus, supply_days?: number | null, store_amount: number, product: { __typename?: 'ProductItem', title: string, amount: number, price: number, id: string, supply_days?: number | null, store: { __typename?: 'MerchantStore', id: number, city: { __typename?: 'City', id: number, name: string } } }, request_item?: { __typename?: 'RequestItem', id: string } | null, request_proposal_item?: { __typename?: 'RequestProposalItem', id: string, amount: number, price: number, supply_days?: number | null } | null, order_merchant: { __typename?: 'OrderMerchant', order: { __typename?: 'Order', id: string, num: string } } }> | null, orders?: Array<{ __typename?: 'Order', id: string, status: OrderStatus, num: string, summ: number, delivery_summ?: number | null }> | null } };

export type PlaceRequestMutationVariables = Exact<{
  data: RequestPayload;
  requestId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PlaceRequestMutation = { __typename?: 'Mutation', placeRequest: { __typename?: 'Request', id: string } };

export type RequestOrderDraftMutationVariables = Exact<{
  items: Array<RequestOrderItemPayload> | RequestOrderItemPayload;
  requestId: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RequestOrderDraftMutation = { __typename?: 'Mutation', requestOrderDraft: { __typename?: 'Order', id: string, company?: { __typename?: 'Company', id: number, inn: string, name: string, address?: string | null } | null } };

export type RequestOpenMutationVariables = Exact<{
  requestOpenId: Scalars['String']['input'];
}>;


export type RequestOpenMutation = { __typename?: 'Mutation', requestOpen: boolean };

export type RequestDeleteMutationVariables = Exact<{
  requestDeleteId: Scalars['String']['input'];
}>;


export type RequestDeleteMutation = { __typename?: 'Mutation', requestDelete: boolean };

export type RequestCloseMutationVariables = Exact<{
  requestCloseId: Scalars['String']['input'];
}>;


export type RequestCloseMutation = { __typename?: 'Mutation', requestClose: boolean };

export type RequestOrderMutationVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type RequestOrderMutation = { __typename?: 'Mutation', requestOrder: { __typename?: 'Order', id: string } };

export type HelpMailRequestQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
  message: Scalars['String']['input'];
}>;


export type HelpMailRequestQuery = { __typename?: 'Query', helpRequestMail: boolean };

export type AutoSuggestProposalsQueryVariables = Exact<{
  requestId: Scalars['String']['input'];
}>;


export type AutoSuggestProposalsQuery = { __typename?: 'Query', autoSuggestProposals: boolean };


export const AllCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AllCategories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parent_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"top_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<AllCategoriesQuery, AllCategoriesQueryVariables>;
export const DataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Data"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor_code"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"top_category"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode<DataQuery, DataQueryVariables>;
export const SubCategoriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SubCategories"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parent_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"categories"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"parent_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parent_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"top_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<SubCategoriesQuery, SubCategoriesQueryVariables>;
export const GetCategoriesBySlugDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategoriesBySlug"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parent_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"top_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoriesBySlugQuery, GetCategoriesBySlugQueryVariables>;
export const GetCategoryByIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCategoryById"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"category_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"parent_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}}]}},{"kind":"Field","name":{"kind":"Name","value":"top_category"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<GetCategoryByIdQuery, GetCategoryByIdQueryVariables>;
export const StatisticsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"statistics"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"}},{"kind":"Field","name":{"kind":"Name","value":"merchants"}}]}}]}}]}}]} as unknown as DocumentNode<StatisticsQuery, StatisticsQueryVariables>;
export const CitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Cities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gmt_offset"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"gmt_offset"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]} as unknown as DocumentNode<CitiesQuery, CitiesQueryVariables>;
export const NewInvestLeadDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"NewInvestLead"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"lead"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InvestLeadPayload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notes"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"newInvestLead"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"lead"},"value":{"kind":"Variable","name":{"kind":"Name","value":"lead"}}},{"kind":"Argument","name":{"kind":"Name","value":"notes"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notes"}}}]}]}}]} as unknown as DocumentNode<NewInvestLeadMutation, NewInvestLeadMutationVariables>;
export const PlaceOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlaceOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"summ"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"OrderItemInput"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"summ"},"value":{"kind":"Variable","name":{"kind":"Name","value":"summ"}}},{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PlaceOrderMutation, PlaceOrderMutationVariables>;
export const ChangeOrderItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ChangeOrderItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"changeOrderItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderItemId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderItemId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ChangeOrderItemMutation, ChangeOrderItemMutationVariables>;
export const RegionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Regions"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"regions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<RegionsQuery, RegionsQueryVariables>;
export const DistrictsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Districts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"districts"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DistrictsQuery, DistrictsQueryVariables>;
export const AuthIsRegisteredDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AuthIsRegistered"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"authIsRegistered"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<AuthIsRegisteredQuery, AuthIsRegisteredQueryVariables>;
export const LoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<LoginMutation, LoginMutationVariables>;
export const RegisterDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Register"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RegisterPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"register"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<RegisterMutation, RegisterMutationVariables>;
export const RestorePasswordSendCodeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestorePasswordSendCode"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restorePasswordSendCode"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkId"}}]}}]}}]} as unknown as DocumentNode<RestorePasswordSendCodeMutation, RestorePasswordSendCodeMutationVariables>;
export const RestorePasswordFinishDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RestorePasswordFinish"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"restorePasswordFinish"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"checkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}}}]}]}}]} as unknown as DocumentNode<RestorePasswordFinishMutation, RestorePasswordFinishMutationVariables>;
export const FastLoginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"FastLogin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fastLogin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}}},{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"district"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<FastLoginMutation, FastLoginMutationVariables>;
export const GetProductsPaginatedDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProductsPaginated"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"products"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"category_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category_id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsPaginatedQuery, GetProductsPaginatedQueryVariables>;
export const GetProductsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetProducts"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"products"},"name":{"kind":"Name","value":"productsSearch"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"top_category"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetProductsQuery, GetProductsQueryVariables>;
export const ProductDetailsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ProductDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"productId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"product_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"productId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor_code"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"top_category"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"sort_order"}}]}}]}}]}}]} as unknown as DocumentNode<ProductDetailsQuery, ProductDetailsQueryVariables>;
export const SendSuggestionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendSuggestion"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestionPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendSuggestion"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"suggestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}}}]}]}}]} as unknown as DocumentNode<SendSuggestionMutation, SendSuggestionMutationVariables>;
export const ContactManagerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ContactManager"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"SuggestionPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"contactManager"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"suggestion"},"value":{"kind":"Variable","name":{"kind":"Name","value":"suggestion"}}}]}]}}]} as unknown as DocumentNode<ContactManagerMutation, ContactManagerMutationVariables>;
export const SpecificationRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SpecificationRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"address"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"files"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"comment"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specificationRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"address"},"value":{"kind":"Variable","name":{"kind":"Name","value":"address"}}},{"kind":"Argument","name":{"kind":"Name","value":"files"},"value":{"kind":"Variable","name":{"kind":"Name","value":"files"}}},{"kind":"Argument","name":{"kind":"Name","value":"comment"},"value":{"kind":"Variable","name":{"kind":"Name","value":"comment"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<SpecificationRequestMutation, SpecificationRequestMutationVariables>;
export const SpecificationRecognitionQueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SpecificationRecognitionQuery"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"specificationRecognition"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recognition_status"}},{"kind":"Field","name":{"kind":"Name","value":"request_id"}}]}}]}}]} as unknown as DocumentNode<SpecificationRecognitionQueryQuery, SpecificationRecognitionQueryQueryVariables>;
export const CompaniesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companies"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inn"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<CompaniesQuery, CompaniesQueryVariables>;
export const CompanyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Company"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"company"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inn"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"companyBillings"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"bik"}},{"kind":"Field","name":{"kind":"Name","value":"bank_name"}},{"kind":"Field","name":{"kind":"Name","value":"account"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}}]}}]}}]} as unknown as DocumentNode<CompanyQuery, CompanyQueryVariables>;
export const CompanyCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanyCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CompanyPayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"inn"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CompanyCreateMutation, CompanyCreateMutationVariables>;
export const CompanyBillingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CompanyBilling"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyBilling"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"is_active"}},{"kind":"Field","name":{"kind":"Name","value":"bik"}},{"kind":"Field","name":{"kind":"Name","value":"bank_name"}},{"kind":"Field","name":{"kind":"Name","value":"account"}}]}}]}}]} as unknown as DocumentNode<CompanyBillingQuery, CompanyBillingQueryVariables>;
export const CompanyBillingCreateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanyBillingCreate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingPayload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyBillingCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CompanyBillingCreateMutation, CompanyBillingCreateMutationVariables>;
export const CompanyBillingUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CompanyBillingUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"BillingPayload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"billingId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"companyBillingUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"billingId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CompanyBillingUpdateMutation, CompanyBillingUpdateMutationVariables>;
export const LookupCompanyByInnDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupCompanyByINN"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"inn"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"company"},"name":{"kind":"Name","value":"lookupCompanyByINN"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"inn"},"value":{"kind":"Variable","name":{"kind":"Name","value":"inn"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]} as unknown as DocumentNode<LookupCompanyByInnQuery, LookupCompanyByInnQueryVariables>;
export const LookupBankByBikDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LookupBankByBIK"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"bik"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"bank"},"name":{"kind":"Name","value":"lookupBankByBIK"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"bik"},"value":{"kind":"Variable","name":{"kind":"Name","value":"bik"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<LookupBankByBikQuery, LookupBankByBikQueryVariables>;
export const ProfileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"personal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}},{"kind":"Field","name":{"kind":"Name","value":"patronymic"}},{"kind":"Field","name":{"kind":"Name","value":"position"}}]}},{"kind":"Field","name":{"kind":"Name","value":"billing"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bik"}},{"kind":"Field","name":{"kind":"Name","value":"account"}}]}},{"kind":"Field","name":{"kind":"Name","value":"manager"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phone"}},{"kind":"Field","name":{"kind":"Name","value":"personal"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"firstname"}},{"kind":"Field","name":{"kind":"Name","value":"patronymic"}},{"kind":"Field","name":{"kind":"Name","value":"surname"}}]}}]}}]}}]}}]} as unknown as DocumentNode<ProfileQuery, ProfileQueryVariables>;
export const ProfileUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ProfileUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ProfilePayload"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"profileUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<ProfileUpdateMutation, ProfileUpdateMutationVariables>;
export const CityUpdateDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CityUpdate"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cityUpdate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cityId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cityId"}}}]}]}}]} as unknown as DocumentNode<CityUpdateMutation, CityUpdateMutationVariables>;
export const HelpMailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpMail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<HelpMailQuery, HelpMailQueryVariables>;
export const OrdersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Orders"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"OrdersListFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"orders"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}},{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"summ"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"num"}}]}}]}}]}}]} as unknown as DocumentNode<OrdersQuery, OrdersQueryVariables>;
export const MutationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"Mutation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}]}]}}]} as unknown as DocumentNode<MutationMutation, MutationMutationVariables>;
export const OrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Order"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"summ"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_summ"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_address"}},{"kind":"Field","name":{"kind":"Name","value":"num"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"productItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"store_amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"request_proposal_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}}]}},{"kind":"Field","name":{"kind":"Name","value":"position_num"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"request"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"num"}}]}}]}}]}}]} as unknown as DocumentNode<OrderQuery, OrderQueryVariables>;
export const HelpMailOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpMailOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpOrderMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<HelpMailOrderQuery, HelpMailOrderQueryVariables>;
export const QueryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Query"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"filter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestsListFilter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requests"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pagination"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}}]}},{"kind":"Argument","name":{"kind":"Name","value":"filter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"filter"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"totalCount"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"num"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<QueryQuery, QueryQueryVariables>;
export const RequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Request"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"request"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"num"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"comment"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"created_at"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"region"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"specification"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requestItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"measure"}},{"kind":"Field","name":{"kind":"Name","value":"category_id"}},{"kind":"Field","name":{"kind":"Name","value":"proposals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"requestItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productItem"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orderItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"store_amount"}},{"kind":"Field","name":{"kind":"Name","value":"product"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}},{"kind":"Field","name":{"kind":"Name","value":"store"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"city"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"request_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"request_proposal_item"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"supply_days"}}]}},{"kind":"Field","name":{"kind":"Name","value":"order_merchant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"order"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"num"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"orders"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"num"}},{"kind":"Field","name":{"kind":"Name","value":"summ"}},{"kind":"Field","name":{"kind":"Name","value":"delivery_summ"}}]}}]}}]}}]} as unknown as DocumentNode<RequestQuery, RequestQueryVariables>;
export const PlaceRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PlaceRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestPayload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"placeRequest"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"request_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<PlaceRequestMutation, PlaceRequestMutationVariables>;
export const RequestOrderDraftDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestOrderDraft"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"items"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequestOrderItemPayload"}}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestOrderDraft"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"items"},"value":{"kind":"Variable","name":{"kind":"Name","value":"items"}}},{"kind":"Argument","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"companyId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"companyId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"company"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"inn"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}}]}}]}}]} as unknown as DocumentNode<RequestOrderDraftMutation, RequestOrderDraftMutationVariables>;
export const RequestOpenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestOpen"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestOpenId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestOpen"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestOpenId"}}}]}]}}]} as unknown as DocumentNode<RequestOpenMutation, RequestOpenMutationVariables>;
export const RequestDeleteDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestDelete"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestDeleteId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestDelete"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestDeleteId"}}}]}]}}]} as unknown as DocumentNode<RequestDeleteMutation, RequestDeleteMutationVariables>;
export const RequestCloseDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestClose"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestCloseId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestClose"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestCloseId"}}}]}]}}]} as unknown as DocumentNode<RequestCloseMutation, RequestCloseMutationVariables>;
export const RequestOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"RequestOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requestOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<RequestOrderMutation, RequestOrderMutationVariables>;
export const HelpMailRequestDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"HelpMailRequest"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"message"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"helpRequestMail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"requestId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}},{"kind":"Argument","name":{"kind":"Name","value":"message"},"value":{"kind":"Variable","name":{"kind":"Name","value":"message"}}}]}]}}]} as unknown as DocumentNode<HelpMailRequestQuery, HelpMailRequestQueryVariables>;
export const AutoSuggestProposalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AutoSuggestProposals"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"autoSuggestProposals"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"request_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requestId"}}}]}]}}]} as unknown as DocumentNode<AutoSuggestProposalsQuery, AutoSuggestProposalsQueryVariables>;